import { motion, useReducedMotion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 32, className = "" }) => {
    const reduce = useReducedMotion();
    return (
        <motion.div
            className={className}
            initial={{ opacity: 0, y: reduce ? 0 : y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
        >
            {children}
        </motion.div>
    );
};

export const SectionHeader = ({ eyebrow, title, intro, align = "left" }) => {
    const reduce = useReducedMotion();
    const centered = align === "center";
    return (
        <div className={centered ? "mx-auto max-w-3xl text-center" : "max-w-3xl"}>
            {eyebrow && (
                <div className={centered ? "flex flex-col items-center" : "flex flex-col items-start"}>
                    <p className="eyebrow" data-testid="section-eyebrow">
                        {eyebrow}
                    </p>
                    <motion.span
                        aria-hidden="true"
                        className="mt-3 block h-0.5 w-12 origin-left rounded-full"
                        style={{ background: "linear-gradient(90deg, var(--t-accent), transparent)" }}
                        initial={{ scaleX: reduce ? 1 : 0, opacity: reduce ? 1 : 0 }}
                        whileInView={{ scaleX: 1, opacity: 1 }}
                        viewport={{ once: true, margin: "-70px" }}
                        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
                    />
                </div>
            )}
            <motion.h2
                className="mt-4 font-display text-2xl font-semibold leading-tight tracking-tight t-heading sm:text-3xl lg:text-4xl"
                initial={{ opacity: reduce ? 1 : 0, y: reduce ? 0 : 20, filter: reduce ? "none" : "brightness(0.82)" }}
                whileInView={{ opacity: 1, y: 0, filter: "brightness(1)" }}
                viewport={{ once: true, margin: "-70px" }}
                transition={{ duration: 0.75, ease: [0.22, 1, 0.36, 1] }}
            >
                {title}
            </motion.h2>
            {intro && <p className="mt-5 text-base leading-relaxed t-soft md:text-lg">{intro}</p>}
        </div>
    );
};
